import { Home, HomeFeatures, HomeFeaturesProperty } from '@lmc/ts-common'
import { monitoringReportTranslations as translations } from 'locale/monitoringReports'

export type SwitchItem = {
  label: string
  description?: string
  key: keyof SwitchStates
}

export type SwitchStates = Record<
  keyof Pick<
    HomeFeaturesProperty,
    | HomeFeatures.reportsFluids
    | HomeFeatures.reportsFood
    | HomeFeatures.reportsRepositionings
    | HomeFeatures.reportsBowel
    | HomeFeatures.reportsWeight
    | HomeFeatures.reportsMood
    | HomeFeatures.reportsTemperature
    | HomeFeatures.reportsWash
    | HomeFeatures.reportsSocial
    | HomeFeatures.reportsCustom
  >,
  boolean
>

export type SettingConfig = {
  key: string
  translationKey: string
  items: SwitchItem[]
}

export const getSwitchStates = (features: Home['features']) => ({
  reportsBowel: features?.reportsBowel?.enabled || false,
  reportsCustom: features?.reportsCustom?.enabled || false,
  reportsFluids: features?.reportsFluids?.enabled || false,
  reportsFood: features?.reportsFood?.enabled || false,
  reportsWash: features?.reportsWash?.enabled || false,
  reportsTemperature: features?.reportsTemperature?.enabled || false,
  reportsMood: features?.reportsMood?.enabled || false,
  reportsRepositionings: features?.reportsRepositionings?.enabled || false,
  reportsSocial: features?.reportsSocial?.enabled || false,
  reportsWeight: features?.reportsWeight?.enabled || false,
})

export const settingsConfig: SettingConfig[] = [
  {
    key: 'foodAndFluids',
    translationKey: translations.FOOD_AND_FLUIDS_TITLE,
    items: [
      {
        label: translations.FLUIDS_OPTION_LABEL,
        key: HomeFeatures.reportsFluids,
        description: translations.FLUIDS_OPTION_DESCRIPTION,
      },
      {
        label: translations.FOOD_OPTION_LABEL,
        key: HomeFeatures.reportsFood,
        description: translations.FOOD_OPTION_DESCRIPTION,
      },
    ],
  },
  {
    key: 'healthRecordings',
    translationKey: translations.HEALTH_RECORDINGS_TITLE,
    items: [
      {
        label: translations.REPOSITIONINGS_LABEL,
        key: HomeFeatures.reportsRepositionings,
        description: translations.REPOSITIONINGS_DESCRIPTION,
      },
      {
        label: translations.WEIGHT_LABEL,
        key: HomeFeatures.reportsWeight,
        description: translations.WEIGHT_DESCRIPTION,
      },
      {
        label: translations.MOOD_LABEL,
        key: HomeFeatures.reportsMood,
        description: translations.MOOD_DESCRIPTION,
      },
      {
        label: translations.TEMPERATURE_LABEL,
        key: HomeFeatures.reportsTemperature,
        description: translations.TEMPERATURE_DESCRIPTION,
      },
    ],
  },
  {
    key: 'personalCare',
    translationKey: translations.PERSONAL_CARE_TITLE,
    items: [
      {
        label: translations.WASH_LABEL,
        key: HomeFeatures.reportsWash,
        description: translations.WASH_DESCRIPTION,
      },
      // {
      //   label: translations.MENSTRUATION_LABEL,
      //   key: 'menstruation',
      //   description: translations.MENSTRUATION_DESCRIPTION,
      // },
    ],
  },
  {
    key: 'socialEnvironment',
    translationKey: translations.SOCIAL_AND_ENVIRONMENT_TITLE,
    items: [
      // {
      //   label: translations.ENVIRONMENT_LABEL,
      //   key: 'environment',
      //   description: translations.ENVIRONMENT_DESCRIPTION,
      // },
      {
        label: translations.SOCIAL_LABEL,
        key: HomeFeatures.reportsSocial,
        description: translations.SOCIAL_DESCRIPTION,
      },
    ],
  },
  {
    key: 'customReport',
    translationKey: translations.CUSTOM_TITLE,
    items: [
      {
        label: translations.CUSTOM_LABEL,
        key: HomeFeatures.reportsCustom,
        description: translations.CUSTOM_DESCRIPTION,
      },
    ],
  },
]
